import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

const faqs = [
  { q: "faq1q", a: "faq1a" },
  { q: "faq2q", a: "faq2a" },
  { q: "faq3q", a: "faq3a" },
  { q: "faq4q", a: "faq4a" },
  { q: "faq5q", a: "faq5a" },
  { q: "faq6q", a: "faq6a" },
  { q: "faq7q", a: "faq7a" },
];

export default function Faq() {
  const { t } = useLang();

  return (
    <section id="faq" className="py-28 lg:py-40 bg-navy-800/40 border-y border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
        <motion.div {...reveal} className="lg:col-span-4">
          <div className="lg:sticky lg:top-36">
            <p className="overline-label" data-testid="faq-overline">{t("q_over")}</p>
            <h2 className="mt-6 font-serif font-semibold text-4xl sm:text-5xl tracking-tight leading-tight" data-testid="faq-heading">
              {t("q_h1a")} <span className="text-brand-300">{t("q_h1b")}</span>
            </h2>
            <p className="mt-6 text-base text-cream/55 leading-relaxed" data-testid="faq-subcopy">
              {t("q_sub")}
            </p>
          </div>
        </motion.div>

        <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.15 }} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map(({ q, a }, i) => (
              <AccordionItem key={q} value={`item-${i}`} className="border-brand/15">
                <AccordionTrigger
                  className="py-6 font-serif text-lg sm:text-xl text-cream hover:text-brand-300 hover:no-underline transition-colors duration-300"
                  data-testid={`faq-question-${i + 1}`}
                >
                  {t(q)}
                </AccordionTrigger>
                <AccordionContent
                  className="text-sm sm:text-base text-cream/55 leading-relaxed pb-6"
                  data-testid={`faq-answer-${i + 1}`}
                >
                  {t(a)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
